module.exports = __webpack_public_path__ + "static/sport/icon-close.c1b720b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/year/icon-close.png
// module id = CCye
// module chunks = 0